import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import ShareIcon from '../../assets/box-arrow-left.svg';
import styles from './HomePage.module.scss';
import { useAppDispatch, useAppSelector } from "../../hooks/hook";
import { addSelectedMessage, closeBar, isSendMessage } from "../../store/slices/appSlice";
import { createShareChatObj } from "../../utils/utils";
import { useTypedTranslation } from "../../hooks/useTypedTranslation";
import { clickType } from "../../constants/constants";
const ShareChatButton = ({ chat }) => {
    const currentUser = useAppSelector(state => state.app.currentUser);
    const dispatch = useAppDispatch();
    const message = createShareChatObj({ sender: currentUser, shareChat: chat });
    const { t } = useTypedTranslation();
    const clickHandler = () => {
        console.log(message);
        dispatch(addSelectedMessage(message));
        dispatch(isSendMessage(true));
        dispatch(closeBar(clickType.CONTACTS));
    };
    return (_jsx("div", { className: styles.shareChatButton, children: _jsx("button", { onClick: clickHandler, children: _jsxs("div", { className: styles.shareChatButton__container, children: [_jsx("div", { className: styles.shareChatButton__icon, children: _jsx(ShareIcon, {}) }), _jsx("div", { children: t('share') })] }) }) }));
};
export default ShareChatButton;
